import create from 'zustand'

const userStore = create<any>((set) => ({
  store: { authenticated: false, id: null, roles: [] },
  setUser: (user) => set(() => ({ store: user })),
}))

export default userStore
